export * from "/vercel/path0/frontend/node_modules/lodash/lodash.js"